import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pagination-container mt8 mb8" }
const _hoisted_2 = { class: "pagination" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "page-link" }

import { computed } from 'vue';
import type { PageItem } from 'src/models';

// withDefaultsでdefaultを与えても、TS上optional(?)でないとrequired:trueのままになるVueの仕様
// https://github.com/vuejs/core/blob/v3.5.35/packages/compiler-sfc/src/script/resolveType.ts (required: !e.optional)
// currentPage/totalItems/itemsPerPageは全呼び出し元が渡しているため必須のまま。autoHideのみoptionalのまま
interface Props {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  autoHide?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    currentPage: {},
    totalItems: {},
    itemsPerPage: {},
    autoHide: { type: Boolean, default: true }
  },
  emits: ['page-click'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const maxPage = computed<number>(() => {
  return Math.ceil(props.totalItems / props.itemsPerPage);
});
const shouldHide = computed<boolean>(() => {
  if (!props.autoHide) return false;

  return maxPage.value < 2;
});
const pageItems = computed<PageItem[]>(() => {
  const fromPage = 1;
  const toPage = maxPage.value;
  const ret: PageItem[] = [];
  for (let n = fromPage; n <= toPage; n++) {
    ret.push({ pageNum: n });
  }
  return ret;
});

const pageClick = (pageNum: number) => {
  emit('page-click', { pageNum });
};
const prevPageClick = () => {
  if (props.currentPage <= 1) return;

  pageClick(props.currentPage - 1);
};
const nextPageClick = () => {
  if (props.currentPage >= maxPage.value) return;

  pageClick(props.currentPage + 1);
};

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", {disabled: __props.currentPage <= 1}]),
        onClick: prevPageClick
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("a", { class: "page-link" }, "«", -1)
      ]))], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageItems.value, ({ pageNum }) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["page-item", {active: pageNum === __props.currentPage}]),
          key: pageNum,
          onClick: ($event: any) => (pageClick(pageNum))
        }, [
          _createElementVNode("a", _hoisted_4, _toDisplayString(pageNum), 1)
        ], 10, _hoisted_3))
      }), 128)),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", {disabled: __props.currentPage >= maxPage.value}]),
        onClick: nextPageClick
      }, [...(_cache[1] || (_cache[1] = [
        _createElementVNode("a", { class: "page-link" }, "»", -1)
      ]))], 2)
    ])
  ], 512)), [
    [_vShow, !shouldHide.value]
  ])
}
}

})